const searchEngineStyle = Object.freeze({
  fontStack: 'alt',
  logoSize: [ { until: 's', value: 3, }, { from: 's', value: 4, }, ],
});

export default searchEngineStyle;
